export enum SugarMoneyApiEnvironmentsEnum {
  Staging = 'staging',
  Development = 'development',
  Preprod = 'preprod',
  Production = 'production',
  Local = 'local',
}

const getApiUrl = ({ environment }: { environment: SugarMoneyApiEnvironmentsEnum }) => {
  if (environment === SugarMoneyApiEnvironmentsEnum.Production) return 'https://sugar.money';
  if (environment === SugarMoneyApiEnvironmentsEnum.Local) return 'http://localhost:3001';

  return `https://${environment}.sugar.money`;
};

export const ApiUrls = {
  [SugarMoneyApiEnvironmentsEnum.Staging]: getApiUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Staging,
  }),
  [SugarMoneyApiEnvironmentsEnum.Development]: getApiUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Development,
  }),
  [SugarMoneyApiEnvironmentsEnum.Preprod]: getApiUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Preprod,
  }),
  [SugarMoneyApiEnvironmentsEnum.Production]: getApiUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Production,
  }),
  [SugarMoneyApiEnvironmentsEnum.Local]: getApiUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Local,
  }),
};

export enum VersionEnum {
  V1 = 'v1',
}

const getWebsocketUrl = ({ environment }: { environment: SugarMoneyApiEnvironmentsEnum }) => {
  if (environment === SugarMoneyApiEnvironmentsEnum.Production) return 'wss://ws.sugar.money';
  if (environment === SugarMoneyApiEnvironmentsEnum.Local) return 'ws://localhost:4223';

  return `wss://${environment}-ws.sugar.money`;
};

export const WebsocketUrls = {
  [SugarMoneyApiEnvironmentsEnum.Staging]: getWebsocketUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Staging,
  }),
  [SugarMoneyApiEnvironmentsEnum.Development]: getWebsocketUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Development,
  }),
  [SugarMoneyApiEnvironmentsEnum.Preprod]: getWebsocketUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Preprod,
  }),
  [SugarMoneyApiEnvironmentsEnum.Production]: getWebsocketUrl({
    environment: SugarMoneyApiEnvironmentsEnum.Production,
  }),
};
